// extracted by mini-css-extract-plugin
module.exports = {"product-image-wrapper":"_2xt2eFGD","no-image":"_1fvU7f13","product-image-icon":"_1d8llTdv","product-image":"_2wVfUJNn","overlay":"_37BDHbKk"};